import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';

export const WorkspaceCollectionDelete = createAction(
  '[WorkspaceCollection] Delete',
  props<{ workspaceId: string; collectionId: string }>()
);
export const WorkspaceCollectionDeleted = createAction(
  '[WorkspaceCollection] Deleted',
  props<{ collectionId: string }>()
);
export const WorkspaceCollectionError = createAction(
  '[WorkspaceCollection] Delete Error',
  props<{ collectionId: string }>()
);

export const initialState: Record<string, CommonApiState<undefined>> = {};

export const workspaceCollectionFeature = createFeature({
  name: 'workspaceCollectionDelete',
  reducer: createReducer(
    initialState,
    on(WorkspaceCollectionDelete, (state, action) => ({
      ...state,
      [action.collectionId]: {
        ...(state[action.collectionId] ?? {}),
        currentPedingApis: (state[action.collectionId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(WorkspaceCollectionDeleted, (state, action) => {
      return {
        ...state,
        [action.collectionId]: {
          ...(state[action.collectionId] ?? {}),
          currentPedingApis: 0,
          isError: false
        }
      };
    }),
    on(WorkspaceCollectionError, (state, action) => {
      return {
        ...state,
        [action.collectionId]: {
          ...(state[action.collectionId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectWorkspaceCollectionDeleteState }) => {
    const workspaceCollectionIsBeingDeleted = (collectionId: string) =>
      createSelector(
        selectWorkspaceCollectionDeleteState,
        workspaceCollectionState => (workspaceCollectionState[collectionId]?.currentPedingApis ?? 0) > 0
      );
    const workspaceCollectionsAreBeingDeleted = createSelector(
      selectWorkspaceCollectionDeleteState,
      workspaceCollectionState =>
        Object.entries(workspaceCollectionState).reduce((curr, [collectionId, value]) => {
          return { ...curr, [collectionId]: value.currentPedingApis > 0 };
        }, {})
    );

    const workspaceCollectionHasPendingRequest = (collectionId: string) =>
      createSelector(
        selectWorkspaceCollectionDeleteState,
        workspaceCollectionState => (workspaceCollectionState[collectionId]?.currentPedingApis ?? 0) >= 2
      );

    return {
      workspaceCollectionIsBeingDeleted,
      workspaceCollectionHasPendingRequest,
      workspaceCollectionsAreBeingDeleted
    };
  }
});
